/* eslint-disable react/no-unknown-property */
import { FuseSplashScreen } from "@fuse";
import { MenuItem, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import Countdown from "app/Core/Components/Countdown/Countdown";
import CidadeApp from "app/ERP/Cidade/CidadeApp";
import Constante from "Constante.json";
import dayjs from "dayjs";
import _ from "lodash";
import MobileDetect from "mobile-detect";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    anotherLine: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#D4D4D4"
    }
});

const NewForm = {
    "formapagamento": "CREDIT_CARD",
    "recorrencia": "",
    "vencimento": dayjs().format("YYYY-MM-DD"),
    "idpessoaformulario": "",
    "idplano": "",
    "quantidade": "",
    "plano": "",
    "planovalor": "",
    "planonome": "",
    "nome": "",
    "documentoprimario": "",
    "email": "",
    "celular": "",
    "logradouro": "",
    "numero": "",
    "complemento": "",
    "bairro": "",
    "cep": "",
    "idcidade": "",
    "cidade": "",
    "uf": "",
    "cidade_nome": "",
};

const AssinaturaPendente = (props) => {

    const { user, xappRouteParams, save, data, Pagamento, verificarPagamento } = props;
    const [form, setForm] = useState(getSugestaoDados());
    const [tab, setTab] = useState(data?.showformulario ? 0 : 1);
    const linkPagamento = data?.linkpagamento ?? Pagamento.data?.linkpagamento;
    const { preload = false, confirmacaoPagamento = false, verificandoPagamento = false } = Pagamento;

    useEffect(() => {
        if (!_.isNull(Pagamento.data) && tab === 0 && Pagamento.data.linkpagamento) {
            setTab(1);
        }
    }, [Pagamento]);

    useEffect(() => {
        if (!_.isNull(form.idplano) && !_.isNull(form.quantidade) && form.idplano !== "" && form.quantidade !== "") {
            let APlano = _.find(data?.servicos, { "idgrupo": form.idplano, "qtdprofissionais": form.quantidade });
            if (!_.isUndefined(APlano)) {
                if ((!_.isEqual(form.plano, APlano.idpessoaformulario) || _.isNull(form.plano) || form.plano === "")) {
                    handleChangePlano();
                }
            }
            else {
                if (form.plano !== "") {
                    setForm(_.set({ ...form }, "plano", ""));
                }
            }
        }
    }, [form]);

    function canBeSubmitted() {
        return (
            !_.isNull(form.plano) && form.plano.length > 0 &&
            !_.isNull(form.planovalor) && form.planovalor.length > 0 &&
            !_.isNull(form.recorrencia) && form.recorrencia.length > 0 &&
            !_.isNull(form.nome) && form.nome.length > 0 &&
            !_.isNull(form.documentoprimario) && (form.documentoprimario.length === 11 || form.documentoprimario.length === 14) &&
            !_.isNull(form.email) && form.email.length > 0 &&
            !_.isNull(form.celular) && form.celular.length > 10 &&
            !_.isNull(form.logradouro) && form.logradouro.length > 0 &&
            !_.isNull(form.numero) && form.numero.length > 0 &&
            !_.isNull(form.bairro) && form.bairro.length > 0 &&
            !_.isNull(form.cep) && form.cep.length > 8 &&
            //  !_.isNull(form.complemento) && form.complemento.length > 0 &&
            !_.isNull(form.idcidade) && form.idcidade.length > 0
        );
    }

    function getSugestaoDados() {
        let APlano = null;
        if (!_.isUndefined(user.settings.sistemas[xappRouteParams.empresa]?.clientexapp?.idplano)) {
            APlano = _.find(data?.servicos, { "idpessoaformulario": String(user.settings.sistemas[xappRouteParams.empresa].clientexapp.idplano) });
        }
        if (_.isUndefined(APlano)) {
            APlano = null;
        }

        return {
            ...NewForm,
            ...user.settings.sistemas[xappRouteParams.empresa]?.clientexapp,
            "nome": user.nome,
            "email": user.login,
            "celular": user.contato,
            "idplano": !_.isNull(APlano) ? APlano.idgrupo : "",
            "quantidade": !_.isNull(APlano) ? APlano.qtdprofissionais : "",
            "plano": !_.isNull(APlano) ? APlano.idpessoaformulario : "",
            "planovalor": !_.isNull(APlano) ? APlano.valor : "",
            "recorrencia": !_.isNull(APlano) ? getRecorrencia(APlano.recorrencia) : "",
            "planonome": !_.isNull(APlano) ? APlano.nomevalor : "",
            "idagendamento": "",
            "idagendamentopessoaformulario": "",
        };
    }

    function handleLookupCidade(_AValue) {
        let tmp = { ...form };
        if (_AValue !== null && _AValue.length > 0) {
            tmp.idcidade = _AValue[0].id;
            tmp.uf = _AValue[0].uf;
            tmp.cidade = _AValue[0].cidade;
            tmp.cidade_nome = _AValue[0].cidade + " - " + _AValue[0].pais;
        }
        else {
            tmp.idcidade = "";
            tmp.uf = "";
            tmp.cidade = "";
            tmp.cidade_nome = "";
        }
        setForm(_.set({ ...tmp }));
    }

    function getRecorrencia(_AValue = "") {
        switch (_AValue.toUpperCase()) {
            case "SEMANAL": return "WEEKLY";
            case "MENSAL": return "MONTHLY";
            case "ANUAL": return "YEARLY";
            default: return "MONTHLY";
        }
    }

    function handleChangePlano() {
        let tmp = { ...form };
        let APlano = _.find(data?.servicos, { "idgrupo": form.idplano, "qtdprofissionais": form.quantidade });
        if (!_.isUndefined(APlano)) {
            tmp.plano = APlano.idpessoaformulario;
            tmp.planovalor = APlano.valor;
            tmp.planonome = APlano.nomevalor;
            tmp.recorrencia = getRecorrencia(APlano.recorrencia);
        }

        setForm(_.set({ ...tmp }));
    }

    function checkPagamento() {
        verificarPagamento({ ...data }, { empresa: Constante.idxapp });
    }

    function getPlanos() {
        let AResponse = [];
        if (!_.isNull(data) && !_.isNull(data.servicos)) {
            data.servicos.forEach(grupo => {
                if (_.findIndex(AResponse, { idgrupo: grupo.idgrupo }) < 0) {
                    AResponse.push({ "idgrupo": grupo.idgrupo, "nome": grupo.gruponome });
                }
            });
        }
        return AResponse;
    }

    function getQuantidades() {
        let AResponse = [];
        if (!_.isNull(data) && !_.isNull(data.servicos)) {
            let tmp = _.filter(data.servicos, { idgrupo: form.idplano });
            tmp.forEach(item => {
                AResponse.push({ "id": item.qtdprofissionais, "nome": `${item.qtdprofissionais} profissiona${Number(item.qtdprofissionais) > 1 ? "is" : "l"} - ${item.valordescricao}` });
            });
        }
        return _.orderBy(AResponse, "id", "asc");
    }

    function handleChange(ev) {
        setForm(_.set({ ...form }, ev.target.name, ev.target.value));
    }

    return (
        <React.Fragment>
            {tab === 0 &&
                <React.Fragment>
                    {!preload ?
                        <React.Fragment>
                            <Typography color="textSecondary" className="block font-medium text-16 my-16 indent-6">
                                {/*"Olá, identificamos problema que requer a ação do usuário administrador do sistema."*/}
                            </Typography>
                            <div className="flex p-8">
                                <Typography className="inline font-medium" color="primary" paragraph={false}>Planos</Typography>
                            </div>
                            <div className="flex w-full xs:flex-wrap gap-8">
                                <TextField
                                    className="mb-12 w-full"
                                    label={"Plano"}
                                    name={"idplano"}
                                    required
                                    value={form.idplano}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                    select
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    {getPlanos().map(item => (
                                        <MenuItem value={item.idgrupo} key={item.idgrupo}>{item.nome}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField
                                    className="mb-12 w-full"
                                    label={"Quantidade de profissionais"}
                                    name={"quantidade"}
                                    required
                                    value={form.quantidade}
                                    onChange={handleChange}
                                    variant="outlined"
                                    fullWidth
                                    select
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                >
                                    <MenuItem value={""} key={""}>{"Selecione um plano"}</MenuItem>
                                    {getQuantidades().map(item => (
                                        <MenuItem value={item.id} key={item.id}>{item.nome}</MenuItem>
                                    ))}
                                </TextField>
                            </div>
                            <div className="flex p-8">
                                <Typography className="inline font-medium" color="primary" paragraph={false}>Dados cadastrais</Typography>
                            </div>
                            <div className="flex w-full xs:flex-wrap gap-8">
                                <TextField
                                    className="hidden"
                                    name={"idpessoaformulario"}
                                    value={form.idpessoaformulario}
                                />
                                <TextField
                                    className="mb-12 w-full"
                                    label={"Nome"}
                                    name={"nome"}
                                    required
                                    value={form.nome}
                                    onChange={ev => setForm(_.set({ ...form }, ev.target.name, ev.target.value))}
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <TextField
                                    className="mb-12 w-full"
                                    required
                                    label="CPF ou CNPJ"
                                    name="documentoprimario"
                                    value={form.documentoprimario}
                                    onChange={ev => setForm(_.set({ ...form }, ev.target.name, ev.target.value.substring(0, 14)))}
                                    variant="outlined"
                                    fullWidth
                                    type="number"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className="flex w-full xs:flex-wrap gap-8">
                                <TextField
                                    className="mb-12 w-full"
                                    label={"Email"}
                                    name={"email"}
                                    required
                                    value={form.email}
                                    onChange={ev => setForm(_.set({ ...form }, ev.target.name, ev.target.value))}
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <InputMask
                                    mask={"(99)99999-9999"}
                                    maskChar={null}
                                    value={form.celular}
                                    onChange={ev => setForm(_.set({ ...form }, ev.target.name, ev.target.value))}
                                >
                                    {() => <TextField
                                        className="mb-12 w-full"
                                        required
                                        label={"Contato"}
                                        name={"celular"}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />}
                                </InputMask>
                            </div>
                            <div className="flex w-full xs:flex-wrap gap-8">
                                <TextField
                                    className="mb-12 w-full"
                                    label={"Logradouro"}
                                    name={"logradouro"}
                                    value={form.logradouro}
                                    onChange={ev => setForm(_.set({ ...form }, ev.target.name, ev.target.value))}
                                    variant="outlined"
                                    fullWidth
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <TextField
                                    className="mb-12 w-1/4 xs:w-full"
                                    label={"Número"}
                                    name={"numero"}
                                    value={form.numero}
                                    onChange={ev => setForm(_.set({ ...form }, ev.target.name, ev.target.value))}
                                    variant="outlined"
                                    fullWidth
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <InputMask
                                    mask={"99999-999"}
                                    maskChar={null}
                                    value={form.cep}
                                    onChange={ev => setForm(_.set({ ...form }, ev.target.name, ev.target.value))}
                                >
                                    {() => <TextField
                                        className="mb-12 w-1/3 xs:w-full"
                                        label={"CEP"}
                                        name={"cep"}
                                        variant="outlined"
                                        fullWidth
                                        required
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />}
                                </InputMask>
                            </div>
                            <div className="flex w-full xs:flex-wrap gap-8">
                                <TextField
                                    className="mb-12 w-1/2 xs:w-full"
                                    label={"Bairro"}
                                    name={"bairro"}
                                    value={form.bairro}
                                    onChange={ev => setForm(_.set({ ...form }, ev.target.name, ev.target.value))}
                                    variant="outlined"
                                    fullWidth
                                    required
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <TextField
                                    className="mb-12 w-1/2 xs:w-full"
                                    label={"Complemento"}
                                    name={"complemento"}
                                    value={form.complemento}
                                    onChange={ev => setForm(_.set({ ...form }, ev.target.name, ev.target.value))}
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                                <CidadeApp
                                    xappRouteParams={xappRouteParams}
                                    isLookup={true}
                                    multiSelect={false}
                                    required={true}
                                    id="LookupCidade"
                                    onChange={(ev) => handleLookupCidade(ev)}
                                    selected={form.idcidade ? ([{ "cidade": form.cidade_nome, "id": form.idcidade, "cidade_nome": form.cidade_nome }]) : []}
                                    className="mb-12 w-full"
                                    label={"Cidade"}
                                />
                            </div>
                            <div className="flex justify-end items-center">
                                <XAPPButton
                                    type="Button"
                                    className="bg-green hover:bg-green text-white"
                                    onClick={() => save(form, "CRIAR-ASSINATURA", { empresa: Constante.idxapp })}
                                    variant="contained"
                                    disabled={!canBeSubmitted()}
                                    iconProps={md.mobile() === null && md.tablet() === null ? "mr-8" : "justify-center"}
                                    icon={"save"}
                                    label={"Enviar"}
                                    key={"btnCadastrarAssinatura"}
                                />
                            </div>
                        </React.Fragment>
                        :
                        <div className="px-128">
                            <FuseSplashScreen />
                        </div>
                    }
                </React.Fragment>
            }
            {tab === 1 &&
                <div className="text-center max-w-320 pt-24">
                    <XAPPButton
                        type="icon"
                        className="bg-green-dark hover:bg-green-dark text-white rounded-full text-24"
                        onClick={() => { }}
                        variant="contained"
                        icon={"done"}
                        key={"iconSucesso"}
                    />
                    <Typography color="textSecondary" variant="h6" className="block font-medium my-24 text-green-dark">
                        Sucesso!
                    </Typography>
                    <Typography color="textSecondary" variant="h6" className="block font-medium text-16 my-24">
                        Assinatura criada, utilize o link abaixo para efetuar o pagamento.
                    </Typography>
                    <XAPPButton
                        type="Button"
                        className="bg-green-dark hover:bg-green-dark text-white rounded-full py-12 my-24"
                        component="a"
                        target="_blank"
                        variant="contained"
                        label={"Acessar pagamento"}
                        href={linkPagamento}
                        key={"btnLinkPagamento"}
                    />
                    {!confirmacaoPagamento ?
                        <div>
                            {verificandoPagamento ?
                                <FuseSplashScreen />
                                :
                                <div>
                                    <Countdown
                                        time={15}
                                        callback={() => checkPagamento()}
                                        texto="Verificando pagamento em"
                                        className=""
                                    />
                                    <a className="cursor-pointer" component="button" onClick={() => checkPagamento()}>Já efetuei o pagamento.</a>
                                </div>
                            }
                        </div>
                        :
                        <div>
                            <Typography className={""}>{"Confirmamos seu pagamento, faça o login novamente para acessar o sistema."}</Typography>
                            <XAPPButton
                                type="Button"
                                className="rounded-full py-12 my-24"
                                variant="outlined"
                                color="primary"
                                label={"Login"}
                                onClick={() => document.location.reload()}
                            />
                        </div>
                    }
                </div>
            }
        </React.Fragment>
    );
};


AssinaturaPendente.propTypes = {
    classes: PropTypes.string,
    data: PropTypes.object,
    user: PropTypes.object,
    xappRouteParams: PropTypes.object,
    Pagamento: PropTypes.object,
    save: PropTypes.func,
    preload: PropTypes.bool,
    verificarPagamento: PropTypes.func,
};

export default withStyles(styles, { withTheme: true })(AssinaturaPendente);